"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unwrap = unwrap;

var _regex = require("./regex");

function unwrap(re, flags) {
  const fragment = re.source.replace(/^\^?([\s\S]*?)\$?$/, '$1');
  return (0, _regex.regex)(flags !== null && flags !== void 0 ? flags : re.flags)`${fragment}`;
}